import React,  { Component, useEffect, useRef }from "react";
import { Navigation } from 'swiper';
// Pagination, Scrollbar, A11y
import { Swiper , SwiperSlide} from "swiper/react";

//import  cursoByOrder  from "./itemCursoByOptions"

import curso from "./cursos/cursos.json"
import facultades from "./cursos/facultades.json";
import dataLic from "./cursos/licenciaturas.json";


import 'swiper/css';
import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';

function ItemCursos(props){
    return(
    <>
   
    <tr>
        <td className="id_program">{props.curso.id_curso}</td>
        <td className="program_name">{props.curso.programa}</td>
        <td className="duratios_program">{props.curso.horas}</td>
    </tr>
    </>

    );
}

function groupBy(key) {
    return function group(array) {
      return array.reduce((acc, obj) => {
        const property = obj[key];
        acc[property] = acc[property] || [];
        acc[property].push(obj);
        return acc;
      }, {});
    };
  }

function ItemCursosO(props){
    return(
    <>
        <tr className={props.curso.opcion}>
            <td className="id_program">{props.curso.id_curso}</td>
            <td className="program_name">{props.curso.programa}</td>
            <td className="duratios_program">{props.curso.horas}</td>
            <td className="options_program">{props.curso.opcion}</td>
        </tr>
    </>

    );
}

function CursoTabla(props){
 const isOptions = props.isOption;
 
    return(
    <>
        
    {(isOptions==='true')?<div className="notice-info-cursos"><p style={{fontSize:16+"px"}}><i>Para el Bloque 2, podrás elegir una de las siguientes opciones</i></p></div>:''}
    { (([1,2,3, 49,24,27, 29, 33,38].indexOf(parseInt( props.id)) ) >=0 )?<div className="notice-info-cursos"><p style={{fontSize:16+"px"}}><i>*Para liberar el requisito del bloque 2, deberás cargar los siguientes cursos</i></p></div> : ''}
    <table className="table shadow">
        <thead>
            <tr>
                <th scope="col">clave</th>
                <th scope="col">Asignatura</th>
                <th scope="col">Horas</th>
                <th></th>
            </tr>
            </thead>
            <tbody>{

//const result = Object.groupBy(inventory, ({ type }) => type);
              // props.curso.filter((curso)=>curso.id_licenciatura === props.id).sort((a,b)=> a.option - b.option)
              props.curso.filter((curso)=>curso.id_licenciatura === props.id)
                .map(( cur, index) =>( 
                    cur.opciones !==''?<ItemCursosO key={index} curso={cur}  />: <ItemCursos key={index} curso={cur}/>
                )
                )
                }
            </tbody>
    </table>
    </>

    );
}

function OptionoptFaces(props){
    return (
        <option value={props.fac.id_facultad}>{props.fac.facultad}</option>
    ) 
}
function OptionsLicenciatura(props){
    return (
        <option value={props.lic.id_licenciatura}>{ props.lic.licenciatura }</option>
    ) 
}
function HeaderTitle(props){
    return(
        <div className="header-licenciatura py-4 text-start">
            <h2 className="title-licencituras-header"> Lic. { props.curso.licenciatura }</h2>      
        </div>
    );
}



export default class Cursos extends Component {
 

    constructor ( props ){
        super(props);

        this.state = {
            optFac:0,
            optLic:0,
            curso: curso.data,
            licenciaturas: dataLic.data
        }
        this.SelectOptions = this.SelectOptions.bind(this);
        this.updateLic = this.updateLic.bind(this);
        this.UpdateDateId = this.UpdateDateId.bind(this);

      //  this.UpdateDateId()
    }
    SelectOptions(e){
        this.setState({
            optFac: e.target.value
        });
    }
    updateLic(e){
        this.setState({
           optLic: e.target.value
        });
    }
    getImage(id_facultad,portada){
        return `https://www.anahuac.mx/competencias-digitales/sites/default/files/img/Licenciaturas/${portada}`
       // return `/competencias-digitales/sites/default/files/img/Bloque II/IMG/${id_facultad}/${portada}`;
    }

  UpdateDateId()  {
    if( this.state.optFac !== 0 && this.state.optLic === 0){
        console.log(this.state.optFac);
            this.setState({
            licenciaturas: dataLic.data.filter((item)=> item.id_facultad === this.state.optFac)
        })      
    }  
    this.setState({
        licenciaturas: dataLic.data
    }) 
    }
    render(){
        
        return(
        <div>
        
            <div className="container-fluid justify-content-center">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-5 py-2">
                
                        <div className="anahuac-search-section  my-2">
                
                            <select name="selectedFacultad" defaultValue={this.state.optFac}  onChange={ this.SelectOptions } className="form-select form-control " aria-label="Default select example">
                                <option value= "0">Selecciona tu Facultad</option>
                            {  facultades.facultades.map( fac => (
                                <OptionoptFaces key={fac.id_facultad} fac={fac}/> 
                            ))
                            }
                                </select>
                        </div>
                
                    </div>
                    <div className="col-12 col-md-5  py-2">
                        <div className="anahuac-search-section my-2">
                        <select  name="selectedLicenciatura" defaultValue={this.state.optLic}  onChange={ this.updateLic } className="form-select form-control" aria-label="Default select example">
                            <option value="0">Selecciona tu Licenciatura</option>
                            {  this.state.licenciaturas.filter( (lic) => lic.id_facultad === this.state.optFac).map((item)=>(
                                <OptionsLicenciatura key={item.id_licenciatura} lic={item}/>
                            ))
                        }
                            </select>
                            </div>
                    </div>
                </div>
            </div>
        
            <div className="container-fluid ">
                <div className="row justify-content-center">
                    <Swiper
                    modules={[Navigation]}
                    autoHeight = {true}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation
                   // onSlideChange={() => console.log('slide change')}
                   // onSwiper={(swiper) => console.log(swiper)}
                    >
                    {
                            this.state.licenciaturas.filter( (lic)=> lic.id_licenciatura === this.state.optLic || this.state.optLic == 0 )
                            .map( (item, index )=>(
                                <SwiperSlide key={index}>
                                    <div className="row justify-content-center">
                                    <div className="col-12 col-md-6">
                                    
                                    <HeaderTitle key={item.id_licenciatura} curso={item}/>
                              
                                    <div className="licenciatura-table table-responsive py-5">
                                        <CursoTabla key={index} curso={this.state.curso} id={item.id_licenciatura} isOption={item.opciones} />
                                    </div>
                                 
                                </div>
                                <div className=" col-12 col-md-5">
                                    <div className="licenciatura-image">
                                    <img className="img-fluid" src={this.getImage(item.id_facultad,item.portada)} alt="" />
                                    </div>
                                </div>
                                    </div>
                    
                                </SwiperSlide>
                                )
                                
                            )
                        }
                    
                    </Swiper>
                </div>
            </div>
        </div>
        )
    }
}